import { gql } from '@apollo/client';

export const DELETE_COMMUNITY_GROUP_TOPIC = gql`
  mutation DeleteCommunityGroupTopic($communityGroupId: ID!, $topicName: String!) {
    deleteCommunityGroupTopic(communityGroupId: $communityGroupId, topicName: $topicName)
  }
`;
